<template>
	<v-container fluid>
		<div v-if="isLoaded">
			<v-row justify="end">
                <information :text="`${text[locale.split('-')[0]]}`" />
            </v-row>
			<!--table head-->

			<v-divider color="black" />
			<v-row class="subtitle-2" no-gutters>
				<v-col class="text-left" cols="1">{{'Products' | localize}}</v-col>
				<v-divider vertical color="black" />
				<v-col v-for="month in 12"
					class="text-right pa-1"
					:key="month">
					{{ months(month) }}
				</v-col>
				<v-divider vertical color="black" />
				<v-col class="text-center text-pre-wrap font-weight-bold pa-1">{{'Total sales' | localize}} {{`\n`}} ({{'units' | localize}})</v-col>
				<v-divider vertical color="black" />
				<v-col class="text-center text-pre-wrap pa-1">{{'Production plan' | localize}} {{`\n`}} ({{'units' | localize}})</v-col>
				<v-divider vertical color="black" />
				<v-col class="text-center text-pre-wrap pa-1">{{'Inventories' | localize}} ({{'units' | localize}})</v-col>
				<v-divider vertical color="black" />
			</v-row>
			<v-divider color="black" />
			<!--table content-->
			<div v-if="sales?.length > 0">
				<div v-for="item in sales" :key="item.id" class="body-2">
					<v-row class="my-1" no-gutters>
						<v-col class="text-left text-pre-wrap" cols="1">{{item.trademark?.name}} {{ item.model }}</v-col>
						<v-divider vertical />
						<v-col v-for="month in 12"
							:key="`${item.id} - ${month}`"
							class="text-right pr-1 text-pre-wrap">
							{{ formatNumber(monthSale(month, item)) }}
						</v-col>
						<v-divider vertical />
						<v-col class="text-right font-weight-bold pr-1">{{ formatNumber(item.sales_units) }}</v-col>
						<v-divider vertical />
						<v-col class="text-right pr-1">{{ formatNumber(item.production_plan) }}</v-col>
						<v-divider vertical />
						<v-col class="text-right pr-1">{{ formatNumber(item.inventories_end) }}</v-col>
					</v-row>
					<v-divider />
				</div>
			</div>
			<v-row v-else justify="center" class="my-4 error--text">
				No data yet
			</v-row>
		</div>
		<v-row v-else justify="center" class="mt-12">
			<loader />
		</v-row> 
	</v-container>
</template>
<script>
import { getMonth, localeNumber } from '../../../functions/common'
import Information from '../../../layouts/Information.vue';
import Loader from '../../../layouts/Loader.vue'
	
	export default {
		data () {
			return {
				panel: [0],
				isLoaded: false,
				text: {
					en: 'The company’s product sales are broken down by month to assess the impact of competitors’ product launches on its business performance and market position.',
					ro: 'Vânzările de produse ale companiei sunt defalcate pe luni pentru a evalua impactul lansărilor de produse ale concurenților asupra performanțelor sale comerciale și asupra poziției pe piață.',
					ru: 'Продажи продукции компании разбиты по месяцам, чтобы оценить влияние вывода на рынок новых продуктов конкурентами на показатели деятельности компании и её положение на рынке.'
				}
			}
		},
		computed: {
			locale() {
				return this.$store.getters.locale;
			},
			team() {
				return this.$store.getters.team;
			},
			game() {
				return this.$store.getters.game;
			},
			sales() {
				return this.$store.getters.sales_team;
			},
			monthSales() {
				return this.$store.getters.monthSales_team;
			}
		},
		methods: {
			formatNumber(num) {
				let res = 0
				if (num) {
					res = localeNumber(num, this.locale);
				}
				return res;
			},
			months(num) {
				return getMonth(num);
			},
			monthSale(month, item) {
				let res = 0;
				if (this.monthSales?.length > 0) {
					const matched = this.monthSales.filter((it) => it.month == month && it.productId == item.productId);
					if (matched) {
						matched.forEach((ite) => {
							res += ite.sales_normalized
						})
					}
				}
				return res
			}
		},
		components: {Loader, Information},
		async created() {
			if (this.game && this.team) {

				const params = {
					gameId: this.game.id,
					round: this.game.round > 0 ? this.game.round - 1 : 0,
					teamId: this.team.id,
				}

				if (this.monthSales?.length < 1 ) {
					try {
						//get last round sales 
						await this.$store.dispatch('fetchTeamMonthsales', params);
					} catch (error) {
						await this.$store.dispatch('setError', error.message);
					}
				}

				/* get last round team sales */
				if (this.sales == null) {
				
					try {
						await this.$store.dispatch('fetchTeamSales', params);
					}  catch (error) {
						await this.$store.dispatch('setError', error.message);
					}
				}

			} /* */

			this.isLoaded = true;
		}
	}
</script>